import axios from 'axios';
import cookie from 'js-cookie';

const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Generate a report for a project
 * @param {string} projectId - The project ID
 * @param {string} reportType - PERIOD_ACTIVITY, ACTIVITY_LOG, COMPANY_PERFORMANCE, DEFERRED_COST
 * @param {object} filters - Filter object with dateFrom, dateTo, and optional filters
 * @param {number} page - Page number for pagination (Activity Log only)
 * @param {number} pageSize - Page size for pagination (Activity Log only)
 * @returns {Promise<object>} - Report data
 */
export const generateReport = async (projectId, reportType, filters, page = 0, pageSize = 100) => {
    const requestBody = {
        reportType,
        filters,
    };

    // Add pagination for Activity Log
    if (reportType === 'ACTIVITY_LOG') {
        requestBody.page = page;
        requestBody.pageSize = pageSize;
    }

    const response = await axios.post(
        `${API_BASE_URL}/projects/${projectId}/reports/generate`,
        requestBody,
        {
            withCredentials: true,
            headers: {
                'X-XSRF-TOKEN': cookie.get('XSRF-TOKEN'),
                'Content-Type': 'application/json',
            },
        }
    );

    return response.data;
};

/**
 * Get unique businesses for users in a project
 * @param {string} projectId - The project ID
 * @returns {Promise<Array>} - Array of unique businesses
 */
export const getBusinessesForProject = async (projectId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/project/get-businesses-for-project/${projectId}`,
            {
                withCredentials: true,
                headers: {
                    'X-XSRF-TOKEN': cookie.get('XSRF-TOKEN'),
                },
            }
        );

        return response.data;
    } catch (error) {
        return []; // Return empty array on error
    }
};

/**
 * Get all floorplans for a project (for filter options)
 * @param {string} projectId - The project ID
 * @returns {Promise<Array>} - Array of floorplans
 */
export const getFloorplansForProject = async (projectId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/floorplans/getFloorplansByProject/${projectId}`,
            {
                withCredentials: true,
                headers: {
                    'X-XSRF-TOKEN': cookie.get('XSRF-TOKEN'),
                },
            }
        );

        return response.data;
    } catch (error) {
        return []; // Return empty array on error
    }
};
